import { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { useAuth } from '../providers/auth';
import api from "../services/api";
import { useToast } from '../context/ToastContext';
import { ALERTAS } from '../utilities/constantes';
import { useForm } from 'react-hook-form';
import { SCCheckbox } from '../components';
import AjudaFormTela from './AjudaFormTela';
import { CheckboxChangeParams } from 'primereact/checkbox';
import Loading from '../components/Loading';

const ConfiguracoesAvaliacoes = () => {
    const toast = useToast();
    const { periodoSelecionado, usuario } = useAuth();
    const tarefa = 'ConfiguracoesAvaliacoes';

    const [avaliacao, setAvaliacao] = useState<any>([]);
    const [loading, setLoading] = useState(false)

    const methods = useForm();
    const { } = methods;

    const load = async () => {
        setLoading(true)
        const boletimAvaliacoes = await api.get('/boletimAvaliacoes', {
            params: {
                EmpresaId: periodoSelecionado?.EmpresaId,
                Ano: periodoSelecionado?.Ano,
                Sequencial: periodoSelecionado?.Sequencial,
            }
        });

        const avaliacoes = await api.get('/boletimAvaliacoes/listAvaliacoes')

        if (avaliacoes.data) {
            const avaliacoesMarcadas = new Set(
                (boletimAvaliacoes.data || []).map((item: any) => item.AvaliacoesId)
            );

            const listaAvaliacoes = avaliacoes.data.map((item: any) => ({
                ...item,
                Selecionado: avaliacoesMarcadas.has(item.AvaliacoesId) ? 1 : 0
            }));

            setAvaliacao(listaAvaliacoes);
        } else {
            setAvaliacao([])
        }
        setLoading(false)
    };

    useEffect(() => {
        load();
    }, []);

    const handleCheckboxChange = (rowData: any, checked: boolean) => {
        const updatedAvaliacao = avaliacao.map((item: any) => {
            if (item.AvaliacoesId === rowData.AvaliacoesId) {
                return { ...item, Selecionado: checked ? 1 : 0 };
            }
            return item;
        });

        setAvaliacao(updatedAvaliacao);
    };

    const onSubmit = async () => {
        try {

            const avaliacoes = await api.get('/boletimAvaliacoes', {
                params: {
                    EmpresaId: periodoSelecionado?.EmpresaId,
                    Ano: periodoSelecionado?.Ano,
                    Sequencial: periodoSelecionado?.Sequencial,
                }
            });

            if (avaliacoes.data.length > 0) {
                await Promise.all(
                    avaliacao.map(async (item: any) => {
                        await api.delete('/boletimAvaliacoes', {
                            params: {
                                AvaliacoesId: item.AvaliacoesId
                            }
                        });
                    })
                )
            }

            await Promise.all(
                avaliacao.map(async (item: any) => {
                    if (item.Selecionado === 1) {
                        const gravacao = {
                            EmpresaId: periodoSelecionado?.EmpresaId,
                            Ano: periodoSelecionado?.Ano,
                            Sequencial: periodoSelecionado?.Sequencial,
                            AvaliacoesId: item.AvaliacoesId,
                        }
                        await api.post('/boletimAvaliacoes', gravacao);
                    }
                })
            )
            toast.showToast({ severity: 'success', summary: 'Atenção', detail: ALERTAS.registroGravado });
            load()

        } catch (e: any) {
            toast.showToast({ severity: 'error', summary: 'Erro', detail: e?.response?.data?.error });
        }
    };

    return (
        <div className="grid crud-demo">
            <div className="col-12">
                <div className="card">
                    <div className='flex justify-content-center align-items-center p-2 border-round-top-md text-white' style={{ backgroundColor: '#0772B3' }}>
                        <h5 className="m-0 flex flex-1 align-items-center justify-content-center">Configuração de Avaliações</h5>
                        <AjudaFormTela tarefa={tarefa} campo='' />
                    </div>

                    {loading ? <Loading /> : (
                        <DataTable
                            size='small'
                            stripedRows
                            value={avaliacao}
                            dataKey="ApagarId"
                            paginator
                            rows={10}
                            rowsPerPageOptions={[5, 10, 25]}
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                            currentPageReportTemplate="{first} a {last} de {totalRecords}"
                            emptyMessage="Nenhum registro encontrado."
                            header={null}
                            responsiveLayout="scroll">
                            <Column field="Codigo" header="Código" />
                            <Column field="Descricao" header="Descrição" />

                            <Column
                                body={(rowData: any) => (
                                    <div className="col-12 flex justify-content-center">
                                        <SCCheckbox
                                            checked={rowData.Selecionado === 1}
                                            onChange={(e: CheckboxChangeParams) => handleCheckboxChange(rowData, e.checked)}
                                            id={rowData.ApagarId}
                                            name="Selecionado"
                                        />
                                    </div>
                                )}
                                alignHeader='center'
                                align='center'
                            />
                        </DataTable>
                    )}

                    <div className='grid flex justify-content-center'>
                        <div className='col-12 md:col-10 pt-4 flex justify-content-center align-items-center'></div>
                        <div className='col-12 md:col-2 flex justify-content-end mt-2 '>
                            <Button label='Gravar' icon="pi pi-plus-o" className="p-button-success" type='button' style={{ width: '100%' }} onClick={onSubmit} />
                        </div>
                    </div>

                </div>
            </div>
        </div>

    );
};

export default ConfiguracoesAvaliacoes;